import { useQuery } from '@tanstack/react-query'
import { featureQueries, isFeature } from '../api/features'
import type { Feature } from '../generated/api/features'

/**
 * The feature flags on for the signed-in user, read as `enabledFeatures.<flag>`: those `GET /features` answers in
 * `enabled`, plus, given the society the screen's content belongs to, the ones on for that society.
 */
export const useFeatures = (
  societyId?: string
): {
  enabledFeatures: Partial<Record<Feature, true>>
  isLoading: boolean
} => {
  const { data, isLoading } = useQuery(featureQueries.getFeatures())
  const societyFeatures =
    societyId == null ? [] : data?.societies[societyId] ?? []

  return {
    enabledFeatures: Object.fromEntries(
      [...(data?.enabled ?? []), ...societyFeatures]
        .filter(isFeature)
        .map((feature) => [feature, true] as const)
    ),
    isLoading,
  }
}
